export default __webpack_public_path__ + "static/media/upstock.b7e3d419.svg";